import { fetcher } from "../helpers/global";
import {
  COMMERCE_CAMPAIGN_PATH,
  COMMERCE_CHECKOUT_OPTION_PRESETS_HONOREE,
  COMMERCE_CHECKOUT_OPTION_PRESETS_JOINT_GIFT,
  COMMERCE_CHECKOUT_OPTION_PRESETS_PLEDGE,
  COMMERCE_CAMPAIGN_FUND,
  COMMERCE_WEBFORM_ID,
  COMMERCE_WEBFORM_PATH,
  COMMERCE_WEBFORM_TOKEN,
  COMMERCE_WEBFORM_SUBMISSION,
  COMMERCE_WEBFORM_CONFIRMATION,
} from "../storage/constants";

export function fetchFundsByCategoryId(fundCategoryId, fundsPage, loadMore) {
  return fetcher(
    "GET",
    "rest/fund-category/" + fundCategoryId,
    { _format: "json", ...(loadMore ? { page: fundsPage } : {}) },
    { accept: "application/json" }
  );
}
export function fetchFilteredFunds(
  fundCategoryId,
  search,
  fundsPage,
  itemsPerPage,
  loadMore
) {
  return fetcher(
    "GET",
    "jsonapi/index/funds",
    {
      "filter[fulltext]": search,
      "filter[fund_parents]": fundCategoryId,
      "filter[status]": 1,
      "page[offset]": loadMore ? fundsPage : 0,
      "page[limit]": itemsPerPage,
    },
    {
      accept: "application/json",
    }
  );
}

export function fetchFundSubcategory(fundCategoryId) {
  return fetcher(
    "GET",
    `rest/fund-subcategory/${fundCategoryId}`,
    { _format: "json" },
    {
      accept: "application/json",
    }
  );
}

export function setHonoreePresets(hide, type) {
  localStorage.setItem(
    COMMERCE_CHECKOUT_OPTION_PRESETS_HONOREE,
    JSON.stringify({ hide: hide, type: type })
  );
}

export function getHonoreePresets() {
  return JSON.parse(
    localStorage.getItem(COMMERCE_CHECKOUT_OPTION_PRESETS_HONOREE)
  );
}

export function resetHonoreePresets() {
  localStorage.setItem(
    COMMERCE_CHECKOUT_OPTION_PRESETS_HONOREE,
    JSON.stringify({ hide: null, type: null })
  );
  return { hide: null, type: null };
}

export function setPledgePresets(hidePledge, isPledge) {
  localStorage.setItem(
    COMMERCE_CHECKOUT_OPTION_PRESETS_PLEDGE,
    JSON.stringify({ hide: hidePledge, isPledge: isPledge })
  );
}

export function getPledgePresets() {
  return JSON.parse(
    localStorage.getItem(COMMERCE_CHECKOUT_OPTION_PRESETS_PLEDGE)
  );
}

export function resetPledgePresets() {
  localStorage.removeItem(COMMERCE_CHECKOUT_OPTION_PRESETS_PLEDGE);
}

export function setJointGiftPresets(hideJointGift) {
  localStorage.setItem(
    COMMERCE_CHECKOUT_OPTION_PRESETS_JOINT_GIFT,
    JSON.stringify({ hide: hideJointGift })
  );
}

export function getJointGiftPresets() {
  return JSON.parse(
    localStorage.getItem(COMMERCE_CHECKOUT_OPTION_PRESETS_JOINT_GIFT)
  );
}

export function resetJointGiftPresets() {
  localStorage.removeItem(COMMERCE_CHECKOUT_OPTION_PRESETS_JOINT_GIFT);
}

export function setCampaignPath(CampaignPath) {
  if (!CampaignPath) {
    CampaignPath = "/give";
  }
  sessionStorage.setItem(COMMERCE_CAMPAIGN_PATH, CampaignPath);
}

export function getCampaignPath() {
  const webform_path = getWebformPath();
  const webform_token = getWebformToken();
  let path = sessionStorage.getItem(COMMERCE_CAMPAIGN_PATH);
  if (path == webform_path && webform_token) {
    path = `${path}?token=${webform_token}`;
  }
  return path;
}

export function setCampaignFundSelected(fundUUID) {
  localStorage.setItem(COMMERCE_CAMPAIGN_FUND, fundUUID);
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: COMMERCE_CAMPAIGN_FUND,
      newValue: fundUUID,
    })
  );
}

export function getCampaignFundSelected() {
  return localStorage.getItem(COMMERCE_CAMPAIGN_FUND);
}

export function resetCampaignFundSelected() {
  return localStorage.removeItem(COMMERCE_CAMPAIGN_FUND);
}

export function getWebformId() {
  return localStorage.getItem(COMMERCE_WEBFORM_ID);
}

export function getWebformPath() {
  return localStorage.getItem(COMMERCE_WEBFORM_PATH);
}

export function getWebformToken() {
  const itemStr = localStorage.getItem(COMMERCE_WEBFORM_TOKEN);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);

  return item.value;
}

export function getWebformSubmission() {
  return localStorage.getItem(COMMERCE_WEBFORM_SUBMISSION);
}

export function getWebformConfirmation() {
  return localStorage.getItem(COMMERCE_WEBFORM_CONFIRMATION);
}

export function resetWebformToken() {
  return localStorage.removeItem(COMMERCE_WEBFORM_TOKEN);
}

export function resetWebformSubmission() {
  return localStorage.removeItem(COMMERCE_WEBFORM_SUBMISSION);
}

export function resetWebformConfirmation() {
  return localStorage.removeItem(COMMERCE_WEBFORM_CONFIRMATION);
}

export function resetWebformId() {
  return localStorage.removeItem(COMMERCE_WEBFORM_ID);
}

export function resetWebformPath() {
  return localStorage.removeItem(COMMERCE_WEBFORM_PATH);
}

export function resetWebform() {
  resetHonoreePresets();
  resetJointGiftPresets();
  resetPledgePresets();
  resetWebformSubmission();
  resetWebformToken();
  resetWebformConfirmation();
  resetWebformPath();
  resetWebformId();
}
